// ==============================|| OVERRIDES - TEXT FIELD ||============================== //

export default function TextField(theme) {
	return {
		MuiInputBase: {
			styleOverrides: {
				root: {
					'& .MuiOutlinedInput-input': {},
					'& .MuiFilledInput-input': {},
					input: {}
				}
			}
		}
	}
}